<div class="input-header">
    <div class="title">
        Add New Grid
    </div>
    <div class="close-button">
        <nb-action>
            <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
        </nb-action> 
    </div>
</div>
